'use client';

import { jsx } from "react/jsx-runtime";
import { X } from "../../../react-icons.js";
import { Button } from "../../atoms/Button/Button.js";
import { dismissLabel, variantToLabelMap } from "./InlineNotification.data.js";
function DismissButton({
  a11yLabel,
  dismissible,
  onDismiss,
  variant
}) {
  if (!dismissible) return null;
  return /* @__PURE__ */ jsx(Button, { emphasis: "low", icon: X, size: "xs", hiddenLabel: true, onClick: onDismiss, children: dismissLabel(a11yLabel || variantToLabelMap[variant]) });
}
export {
  DismissButton
};
